import { render, staticRenderFns } from "./password-reset.vue?vue&type=template&id=101b3303&scoped=true"
import script from "./password-reset.vue?vue&type=script&lang=ts"
export * from "./password-reset.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101b3303",
  null
  
)

export default component.exports